export default "__VITE_ASSET__B$UDEi4B__"